import { SVGAttributes } from 'react';

const StarOutline = (props: SVGAttributes<HTMLOrSVGElement>) => (
  <svg
    {...props}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icons/star">
      <path
        id="Icons/star_2"
        d="M9.07203 2.81085C9.40793 1.97438 10.5921 1.97438 10.928 2.81085L12.3523 6.35774C12.4953 6.71394 12.8297 6.95683 13.2126 6.9828L17.0261 7.24137C17.9254 7.30235 18.2913 8.42853 17.5996 9.00648L14.6664 11.4571C14.3719 11.7033 14.2442 12.0963 14.3378 12.4685L15.2703 16.1752C15.4902 17.0494 14.5322 17.7454 13.7688 17.2661L10.5317 15.2338C10.2066 15.0297 9.79339 15.0297 9.46829 15.2338L6.23117 17.2661C5.46776 17.7454 4.50977 17.0494 4.72969 16.1752L5.66218 12.4685C5.75583 12.0963 5.62814 11.7033 5.33357 11.4571L2.40042 9.00647C1.70869 8.42853 2.07461 7.30235 2.97394 7.24137L6.78737 6.9828C7.17035 6.95683 7.50466 6.71394 7.6477 6.35774L9.07203 2.81085Z"
        stroke="currentColor"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export default StarOutline;
